// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Blinker_wrapper__10GDl","blinking":"Blinker_blinking__39dee","title":"Blinker_title__QOTFG"};